<app-page [dynamicHeight]="true" class="page-wrapper">
  <app-header>
    <h1 app-overline>Create simulation</h1>
    <h2 app-title>Select Pattern Configurations</h2>
    <app-header-actions>
      <mat-slide-toggle
        *ngIf="showDualProductToggle"
        [formControl]="father.zimWizard.dualProductMode"
      >
        Dual Product Mode (beta)
      </mat-slide-toggle>
    </app-header-actions>
  </app-header>

  <ng-container *ngIf="patternTableData$ | async as data">
    <!-- Loading state -->
    <app-loading *ngIf="data.isLoading"></app-loading>

    <!-- Error state -->
    <app-error *ngIf="data.error as error" [error]="error"></app-error>

    <!-- Success state -->
    <ng-container
      *ngIf="father.zimWizard.dualProductMode.value; else singleProductMode"
    >
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          gap: 1em;
        "
      >
        <div style="width: 50%">
          <h2 app-title>Primary pattern</h2>
          <app-table
            #leftPalletTable
            *ngIf="data.didSucceed"
            [clickableRows]="true"
            [clickToSelect]="true"
            [topRow]="false"
            [inputData]="data.value"
            [preSelectedRows]="father.zimWizard.getSelected('patterns', 0)"
            [displayedColumns]="columnsToDisplay"
            [actions]="true"
            [selectionAmount]="'SELECT_SINGLE'"
            [disableBlockSelection]="true"
            (actionClicked)="actionClicked($event)"
            (blockSelectedChange)="father.zimWizard.editPatterns($event, 0)"
          ></app-table>
        </div>
        <mat-divider [vertical]="true"></mat-divider>
        <div style="width: 50%">
          <h2 app-title>Secondary pattern</h2>
          <app-table
            #rightPalletTable
            *ngIf="data.didSucceed"
            [clickableRows]="true"
            [clickToSelect]="true"
            [topRow]="false"
            [inputData]="data.value"
            [preSelectedRows]="father.zimWizard.getSelected('patterns', 1)"
            [displayedColumns]="columnsToDisplay"
            [actions]="true"
            [selectionAmount]="'SELECT_SINGLE'"
            [disableBlockSelection]="true"
            (actionClicked)="actionClicked($event)"
            (blockSelectedChange)="father.zimWizard.editPatterns($event, 1)"
          ></app-table>
        </div>
      </div>
    </ng-container>

    <ng-template #singleProductMode>
      <app-table
        #table
        *ngIf="data.didSucceed"
        [clickableRows]="true"
        [clickToSelect]="true"
        [topRow]="false"
        [inputData]="data.value"
        [preSelectedRows]="father.zimWizard.getSelected('patterns')"
        [displayedColumns]="columnsToDisplay"
        [actions]="true"
        (actionClicked)="actionClicked($event)"
        (blockSelectedChange)="father.zimWizard.editPatterns($event)"
      ></app-table>
    </ng-template>
  </ng-container>
</app-page>
